var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "dense": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.icon.name,
      "label": _vm.label,
      "placeholder": "e.g. mdi:train",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    on: {
      "input": function ($event) {
        return _vm.update('name', $event);
      }
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.icon.color,
      "label": `${_vm.label} Color`,
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    on: {
      "input": function ($event) {
        return _vm.update('color', $event);
      }
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "input-value": _vm.icon.isCustom,
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": ""
    },
    on: {
      "change": function ($event) {
        return _vm.update('isCustom', $event);
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }